/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row2_ChatgptInputs */

const en_mk_cmp_row2_chatgpt = /** @type {(inputs: Mk_Cmp_Row2_ChatgptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individuals`)
};

const id_mk_cmp_row2_chatgpt = /** @type {(inputs: Mk_Cmp_Row2_ChatgptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perorangan`)
};

/**
* | output |
* | --- |
* | "Individuals" |
*
* @param {Mk_Cmp_Row2_ChatgptInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row2_chatgpt = /** @type {((inputs?: Mk_Cmp_Row2_ChatgptInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row2_ChatgptInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row2_chatgpt(inputs)
	return en_mk_cmp_row2_chatgpt(inputs)
});